{
  "instances": {
    "configprops": {
      "label": "Propriétés de configuration",

      "no_properties_set": "Aucune propriétés définies"
    }
  }
}
